import React from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-116">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-117" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-118" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-2 pb-6 text-center" data-id="element-119">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-1" data-id="element-120">
          Vitalidad 360 · Master Kit Adultos Mayores
        </p>
        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-2 text-[24px]" data-id="element-121">
          El Sistema Completo para el Cuidado del Adulto Mayor —{' '}
          <br className="hidden md:block" data-id="element-122" />
          <span className="text-familia-cyan" data-id="element-123">
            Sin Agotarte, Sin Miedo y Sin Improvisar
          </span>
        </h1>
        <div className="relative max-w-[260px] sm:max-w-[374px] mx-auto mb-3" style={{
        aspectRatio: '1 / 1'
      }} data-id="element-124">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/25 rounded-full hidden md:block" style={{
          filter: 'blur(50px)'
        }} data-id="element-125" />
          <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitalidad 360 Master Kit Adultos Mayores Mockup" width="374" height="374" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.35))'
        }} data-id="element-126" />
        </div>
        <p className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-3 text-[10px] leading-relaxed" data-id="element-127">
          5 Módulos + Módulo VIP EJERCICIOS + 3 Bonos:Todo explicado. En letra
          grande. Sin improvisar. Sin adivinar.
        </p>
        <div className="flex flex-wrap gap-1 mb-3 items-start justify-center" data-id="element-128">
          {['📄 PDF Digital', '⚡ Acceso Inmediato', '👴 Adultos Mayores y Cuidadores', '💥 Sistema Completo 2026'].map((badge, i) => <span key={i} className="bg-familia-card border border-familia-cyan/25 px-2.5 py-1 rounded-full text-[9px] sm:text-[11px] font-bold flex items-center gap-1.5" data-id="element-129">
              {badge}
            </span>)}
        </div>
        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-130">
          → LO QUIERO AHORA
        </CTAButton>
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-familia-gray" data-id="element-131">
          <span className="flex items-center gap-1.5" data-id="element-132">
            🛡️ Garantía de satisfacción de 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-133">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-134">
            💳 Tarjeta · Mercado Pago · Ualá · Transferencia
          </span>
        </div>
      </div>
    </header>;
};